<div class="modal-background" [id]="chartContainerId+'_background'"></div> 
<div class="modal" [id]="chartContainerId+'_modal'">
  <div class="btn-group tab_btn_group" style="z-index: 9999;">

    <ng-container *ngIf="graphID === 'trends-cumulative-energy'; else originalButtons">

      <button type="button" [ngClass]="accColor1" [disabled]="accColor1 == 'active'" class="btn" (click)="selectFilterAccelartion('Hourly', chartContainerId)">
        Daily
      </button>
      <button type="button" [ngClass]="accColor2" [disabled]="accColor2 == 'active'" class="btn" (click)="selectFilterAccelartion('Daily', chartContainerId)">
        Weekly
      </button>
      <button type="button" [ngClass]="accColor3" [disabled]="accColor3 == 'active'" class="btn" (click)="selectFilterAccelartion('Weekly', chartContainerId)">
        Monthly
      </button>

    </ng-container>

    <ng-template #originalButtons>

      <button type="button" [ngClass]="accColor1" [disabled]="accColor1 == 'active'" class="btn" (click)="selectFilterAccelartion('Hourly', chartContainerId)">
        Hourly
      </button>
      <button type="button" [ngClass]="accColor2" [disabled]="accColor2 == 'active'" class="btn" (click)="selectFilterAccelartion('Daily', chartContainerId)">
        Daily
      </button>
      <button type="button" [ngClass]="accColor3" [disabled]="accColor3 == 'active'" class="btn" (click)="selectFilterAccelartion('Weekly', chartContainerId)">
        Weekly
      </button>


    </ng-template>
    
  </div>

  <div *ngIf="graphID == 'trends-voltage' || graphID == 'trends-harmonic-distortion' || graphID == 'trends-current' || graphID == 'trends-frequency' || graphID == 'trends-power-factor' || graphID == 'trends-kw-demand'; else DefaultAvgBlock">
  <!-- <div *ngIf="graphID == 'trends-voltage' || graphID == 'trends-harmonic-distortion' || graphID == 'trends-current' || graphID == 'trends-frequency' || graphID == 'trends-power-factor' || graphID == 'trends-kw-demand';"> -->

    <div class="table-responsive" style="z-index: 19; position: relative; margin-left: -32px; margin-top: -21px;" *ngIf="graphID =='trends-voltage' || graphID == 'trends-harmonic-distortion' || graphID == 'trends-current'">
      <table class="moving_avg">
        <thead>
          <tr>
            <th>Period</th>
            <th>Phase A</th>
            <th>Phase B</th>
            <th>Phase C</th>
          </tr>
        </thead>
        <tbody *ngIf="!visibilityVAT; else elseBlock">
          <tr *ngFor="let avgData of movingAvgData; let i = index">
            <th style="text-align: left">
              {{ i === 0 ? '1 Day Avg.' : (i === 1 ? '7 Days Avg.' : '30 Days Avg.') }}
            </th>
            <td>{{ i === 0 ? avgData.xvltavg.toFixed(2) : (i === 1 ? avgData.xvltavg_day.toFixed(2) : avgData.xvltavg_week.toFixed(2)) }}</td>
            <td>{{ i === 0 ? avgData.yvltavg.toFixed(2) : (i === 1 ? avgData.yvltavg_day.toFixed(2) : avgData.yvltavg_week.toFixed(2)) }}</td>
            <td>{{ i === 0 ? avgData.zvltavg.toFixed(2) : (i === 1 ? avgData.zvltavg_day.toFixed(2) : avgData.zvltavg_week.toFixed(2)) }}</td>
          </tr>
        </tbody>
        <tbody>
          <ng-template #elseBlock>
            <tr>
              <td colspan="4" class="errorDisplay">No data available for last 24 Hour!</td>
            </tr>         
          </ng-template>
        </tbody>
      </table>
      
    </div>
  
    <div class="table-responsive" style="z-index: 19; position: relative; margin-left: -32px; margin-top: -21px;" *ngIf="graphID == 'trends-frequency' || graphID == 'trends-power-factor'">
      <table class="moving_avg">
        <thead>
          <tr>
            <th>Period</th>
            <th>Value</th>          
          </tr>
        </thead>
        <tbody *ngIf="!visibilityVAT; else elseBlock">
          <tr *ngFor="let avgData of movingAvgData; let i = index">
            <th style="text-align: left">
              {{ i === 0 ? '1 Day Avg.' : (i === 1 ? '7 Days Avg.' : '30 Days Avg.') }}
            </th>
            <td>{{ i === 0 ? avgData.xvltavg.toFixed(2) : (i === 1 ? avgData.xvltavg_day.toFixed(2) : avgData.xvltavg_week.toFixed(2)) }}</td>         
          </tr>
        </tbody>
        <tbody>
          <ng-template #elseBlock>
            <tr>
              <td colspan="4" class="errorDisplay">No data available for last 24 Hour!</td>
            </tr>         
          </ng-template>
        </tbody>
      </table>
      
    </div>
    <div class="table-responsive" style="z-index: 19; position: relative; margin-left: -32px; margin-top: -21px;" *ngIf="graphID == 'trends-kw-demand'">
      <table class="moving_avg">
        <thead>
          <tr>
            <th>Period</th>
            <th>KW</th>          
            <th>KVA</th>          
          </tr>
        </thead>
        <tbody *ngIf="!visibilityVAT; else elseBlock">
          <tr *ngFor="let avgData of movingAvgData; let i = index">
            <th style="text-align: left">
              {{ i === 0 ? '1 Day Avg.' : (i === 1 ? '7 Days Avg.' : '30 Days Avg.') }}
            </th>
            <td>{{ i === 0 ? avgData.xvltavg.toFixed(2) : (i === 1 ? avgData.xvltavg_day.toFixed(2) : avgData.xvltavg_week.toFixed(2)) }}</td>         
            <td>{{ i === 0 ? avgData.yvltavg.toFixed(2) : (i === 1 ? avgData.yvltavg_day.toFixed(2) : avgData.yvltavg_week.toFixed(2)) }}</td>

          </tr>
        </tbody>
        <tbody>
          <ng-template #elseBlock>
            <tr>
              <td colspan="4" class="errorDisplay">No data available for last 24 Hour!</td>
            </tr>         
          </ng-template>
        </tbody>
      </table>
      
    </div>

  </div>

  <ng-template #DefaultAvgBlock>
    <div class="table-responsive" style="z-index: 19; position: relative; margin-left: -32px; margin-top: -21px;" *ngIf="chartType !== 'column'; else elseCondition">
      <table class="moving_avg">
        <thead>
          <tr>
            <th></th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody *ngIf="!visibilityVAT; else elseBlock">
          <tr>
            <th style="text-align: left">1 Day Avg.</th>
            <td>{{day_1}}</td>
          </tr>
          <tr>
            <th style="text-align: left">7 Days Avg.</th>
            <td>{{days_7}}</td>
          </tr>
          <tr>
            <th style="text-align: left">30 Days Avg.</th>
            <td>{{days_30}}</td>
          </tr>
        </tbody>
        <tbody>
          <ng-template #elseBlock>
            <tr>
              <td colspan="4" class="errorDisplay">No data available for last 24 Hour!</td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </div>
    <ng-template #elseCondition>
      <div class="legendbox" style="margin-top: -10px; margin-right: 30px;">
        <div style="background-color: #ff2a1b;"></div><strong>ON</strong>
        <div style="background-color: #72FF13;"></div><strong>OFF</strong>
      </div>    
    </ng-template>
  </ng-template>

  
  <div *ngIf="graphID == 'trends-voltage' || graphID == 'trends-harmonic-distortion' || graphID == 'trends-current' || graphID == 'trends-frequency' || graphID == 'trends-power-factor' || graphID == 'trends-kw-demand' || graphID == 'trends-cumulative-energy';">
    <strong class="unit" *ngIf="chartSymbol != undefined">({{chartSymbol}})</strong>
  </div>
  <div *ngIf="graphID == 'trends-acc' || graphID == 'trends-temp' || graphID == 'trends-usound' || graphID == 'trends-velocity' || graphID == 'trends-audible' || graphID == 'trends-flow' || graphID == 'trends-pressure'; else DefaultUnitBlock2">
    <strong class="unit" *ngIf="chartSymbol != undefined">({{chartSymbol}})</strong>
  </div>

  <ng-template #DefaultUnitBlock2><strong class="unit" *ngIf="chartUnit != undefined">({{chartUnit}})</strong></ng-template>
  

    <div *ngIf="isLoading;" class="loading-spinner">
      <mat-spinner></mat-spinner>     
    </div>
    

    <div *ngIf="chartType !== 'column'; else forcolumn" [id]="chartContainerId+'_2'"></div>  
    <ng-template #forcolumn>
      
      <div *ngIf="!isLoading;" [id]="chartContainerId+'_2'" ></div>
    </ng-template>
    <span id="closeBtn" class="close-btn"><b>X</b></span>
  
</div>

<div [id]="chartContainerId" style="height:220px; width: 100%;"></div>
